var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1258 9.6176C16.8861 9.86245 16.5611 10 16.2222 10C15.8833 10 15.5583 9.86245 15.3186 9.6176L8.99228 3.15257L2.66593 9.6176C2.42489 9.85551 2.10205 9.98716 1.76695 9.98418C1.43184 9.9812 1.11129 9.84385 0.874332 9.60169C0.637371 9.35954 0.502962 9.03196 0.50005 8.68951C0.497137 8.34706 0.625957 8.01715 0.858765 7.77082L8.0887 0.382399C8.32837 0.137548 8.65339 0 8.99228 0C9.33118 0 9.6562 0.137548 9.89587 0.382399L17.1258 7.77082C17.3654 8.01575 17.5 8.34789 17.5 8.69421C17.5 9.04053 17.3654 9.37268 17.1258 9.6176Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp2);
export default __webpack_public_path__ + "static/media/arrowUp2.0a6e73bcdefe0fb90c746a20d29dee7e.svg";
export { ForwardRef as ReactComponent };